// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"9fe9b391","156":"6c9492be","438":"387cc76a","706":"49f6b1bd","726":"83e1ad3e","785":"95ff5218"}[chunkId] + ".chunk.js";
};